import * as React from 'react';
import {getReactButton} from "../../index";

export interface ReactCheckboxData {
    id?: string,
    name?: string,
    onClick?: (rowOBJ: any, shiftKey: boolean, ctrlKey: boolean, rowIndex: number) => void,
    row: any,
    disabled?: boolean,
    label?: string,
    css?: string,
    style?: {},
    labelStyle?: {},
    disableID?: string,
    refreshID?: string,
    onRefresh?: () => {},
    dataKey: string,
    tabIndex?: null,
    rowIndex?: number,
    title?: string,
    stopPropagationOnClick?: boolean,
    storedData?: any,
    useRowDataStorage?: boolean,
    hiddenSelectedKey?: string,
    hiddenSelectedKeyDelimiter?: string,
    storedDataAsJSONArray?: boolean,
    newJSONData?: (row: any, rowIndex: number, jsonData: any) => {},
    onKeyDown?: (rowOBJ: any, rowIndex: number, keyPressed: string, bShift: boolean, bCTRL: boolean, bALT: boolean) => null,
    onKeyUp?: (rowOBJ: any, rowIndex: number, keyPressed: string, bShift: boolean, bCTRL: boolean, bALT: boolean) => null,
    stopPropagationOnKeyPress?: (rowOBJ: any, rowIndex: number, keyPressed: string, bOnKeyUp: boolean, bShift: boolean, bCTRL: boolean, bALT: boolean) => boolean,
}

export interface ReactCheckboxState {
    row: any,
    storedData: any,
    disabled: boolean,
}

export class ReactCheckbox extends React.Component<ReactCheckboxData> {
    constructor(props: ReactCheckboxData) {
        super(props);

        this.state = {row: props.row, storedData: props.storedData, disabled: props.disabled};

        // Binding is necessary to allow these functions access to the State data
        this.handleChange = this.handleChange.bind(this);
        this.onDisableClick = this.onDisableClick.bind(this);
        this.onRefresh = this.onRefresh.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
    }

    // Update the state externally
    componentWillReceiveProps(props: ReactCheckboxData) {
        this.setState({
            row: props.row,
            storedData: props.storedData,
            disabled: props.disabled
        });
    }

    indexOfStoredDataJSON(data: any, key: string) {
        for (let i = 0; i < data.length; i++) {
            if(data[i][this.props.dataKey] === key) {
                return i;
            }
        }

        return -1;
    }

    getStoredJSONData() {
        let jsonData: any = {};
        jsonData[this.props.dataKey] = (this.state as ReactCheckboxState).row[this.props.hiddenSelectedKey];

        if(null != this.props.newJSONData) {
            jsonData = this.props.newJSONData((this.state as ReactCheckboxState).row, this.props.rowIndex, jsonData);
        }
        return jsonData;
    }

    onKeyPress(event: any) {
        if(null != this.props.onKeyDown) {
            this.props.onKeyDown((this.state as ReactCheckboxState).row, this.props.rowIndex, event.key, event.shiftKey, event.ctrlKey, event.altKey);
        }

        if(null != this.props.stopPropagationOnKeyPress) {
            const selectIndex = this.props.rowIndex;
            const selectRow = (this.state as ReactCheckboxState).row;
            if(this.props.stopPropagationOnKeyPress(selectRow, selectIndex, event.key, false, event.shiftKey, event.ctrlKey, event.altKey)) {
                event.stopPropagation();
            }
        }
    }

    onKeyUp(event: any) {
        if(null != this.props.onKeyUp) {
            this.props.onKeyUp((this.state as ReactCheckboxState).row, this.props.rowIndex, event.key, event.shiftKey, event.ctrlKey, event.altKey);
        }

        if(null != this.props.stopPropagationOnKeyPress) {
            const selectIndex = this.props.rowIndex;
            const selectRow = (this.state as ReactCheckboxState).row;
            if(this.props.stopPropagationOnKeyPress(selectRow, selectIndex, event.key, true, event.shiftKey, event.ctrlKey, event.altKey)) {
                event.stopPropagation();
            }
        }
    }

    handleChange(event: React.MouseEvent<HTMLInputElement, MouseEvent>) {
        this.setState(() => {
            if(this.props.storedDataAsJSONArray) {
                const storageIndex = this.indexOfStoredDataJSON((this.state as ReactCheckboxState).storedData, (this.state as ReactCheckboxState).row[this.props.hiddenSelectedKey]);
                if(storageIndex > -1) {
                    (this.state as ReactCheckboxState).storedData.splice(storageIndex, 1);
                } else {
                    (this.state as ReactCheckboxState).storedData.push(this.getStoredJSONData());
                }
            } else if(this.props.useRowDataStorage) {
                const keyVal = (this.state as ReactCheckboxState).row[this.props.hiddenSelectedKey];

                if(null != (this.state as ReactCheckboxState).storedData[this.props.dataKey] && 'undefined' != (this.state as ReactCheckboxState).storedData[this.props.dataKey]) {
                    const selectedKeyList = (null != (this.state as ReactCheckboxState).storedData[this.props.dataKey] && '' != (this.state as ReactCheckboxState).storedData[this.props.dataKey]) ? (this.state as ReactCheckboxState).storedData[this.props.dataKey].split(this.props.hiddenSelectedKeyDelimiter) : [];
                    const storageIndex = selectedKeyList.indexOf(keyVal);
                    if(storageIndex > -1) {
                        selectedKeyList.splice(storageIndex, 1);
                    } else {
                        selectedKeyList.push(keyVal);
                    }
                    (this.state as ReactCheckboxState).storedData[this.props.dataKey] = selectedKeyList.join(this.props.hiddenSelectedKeyDelimiter);
                } else {
                    (this.state as ReactCheckboxState).storedData[this.props.dataKey] = keyVal;
                }
            } else {
                if(null != (this.state as ReactCheckboxState).row[this.props.dataKey] && 'undefined' != (this.state as ReactCheckboxState).row[this.props.dataKey]) {
                    (this.state as ReactCheckboxState).row[this.props.dataKey] = !(this.state as ReactCheckboxState).row[this.props.dataKey];
                } else {
                    (this.state as ReactCheckboxState).row[this.props.dataKey] = true;
                }
            }

            return {
                row: (this.state as ReactCheckboxState).row,
                storedData: (this.state as ReactCheckboxState).storedData
            }
        }, () => {
            if (null != this.props.onClick) {
                this.props.onClick((this.state as ReactCheckboxState).row, event.shiftKey, event.ctrlKey, this.props.rowIndex);
            }
        });

        if(null != this.props.stopPropagationOnClick && this.props.stopPropagationOnClick) {
            event.stopPropagation();
        }
    }

    onRefresh() {
        if(null != this.props.onRefresh) {
            this.props.onRefresh();
        }

        this.setState(() => ({
            row: (this.state as ReactCheckboxState).row,
            storedData: (this.state as ReactCheckboxState).storedData,
        }));
    }

    onDisableClick(event: any) {
        const isChecked = $(event.currentTarget).is(":checked");
        this.setState({
            disabled: isChecked
        });
    }

    isCheckboxChecked() {
        if(this.props.storedDataAsJSONArray) {
            return this.indexOfStoredDataJSON((this.state as ReactCheckboxState).storedData, (this.state as ReactCheckboxState).row[this.props.hiddenSelectedKey]) > -1;
        } else if(this.props.useRowDataStorage) {
            if (null != (this.state as ReactCheckboxState).storedData[this.props.dataKey] && 'undefined' != (this.state as ReactCheckboxState).storedData[this.props.dataKey]) {
                const keyVal = (this.state as ReactCheckboxState).row[this.props.hiddenSelectedKey];
                const selectedKeyList = (null != (this.state as ReactCheckboxState).storedData[this.props.dataKey] && "" != (this.state as ReactCheckboxState).storedData[this.props.dataKey]) ? (this.state as ReactCheckboxState).storedData[this.props.dataKey].split(this.props.hiddenSelectedKeyDelimiter) : [];
                const storageIndex = selectedKeyList.indexOf(keyVal);
                return (storageIndex > -1);
            } else {
                return false;
            }
        }
         else {
            return (null != (this.state as ReactCheckboxState).row[this.props.dataKey] && 'undefined' != (this.state as ReactCheckboxState).row[this.props.dataKey]) ? (this.state as ReactCheckboxState).row[this.props.dataKey] : false;
        }
    }

    getCheckbox() {
        if(this.props.title) {
            return <input
                id={this.props.id}
                name={this.props.name}
                type="checkbox"
                tabIndex={this.props.tabIndex}
                onClick={this.handleChange}
                onKeyDown={this.onKeyPress}
                onKeyUp={this.onKeyUp}
                checked={this.isCheckboxChecked()}
                disabled={(this.state as ReactCheckboxState).disabled}
                title={this.props.title}
            />
        } else {
            return <input
                id={this.props.id}
                name={this.props.name}
                type="checkbox"
                tabIndex={this.props.tabIndex}
                onClick={this.handleChange}
                onKeyDown={this.onKeyPress}
                onKeyUp={this.onKeyUp}
                checked={this.isCheckboxChecked()}
                disabled={(this.state as ReactCheckboxState).disabled}
            />
        }
    }

    render() {
        return <React.Fragment>
            {<table className="categoryAllHide"><tr>
                <td><input
                    id={this.props.disableID}
                    type="checkbox"
                    onChange={this.onDisableClick}
                    checked={(this.state as ReactCheckboxState).disabled}
                /></td>
                <td>
                    HIDDEN DISABLE BUTTON
                </td>
            </tr></table>
            }
            {getReactButton({id: this.props.refreshID, css: "categoryAllHide", onClick: this.onRefresh, text: "HIDDEN REFRESH BUTTON"})}
            <table className={this.props.css} style={this.props.style}><tr>
                <td>
                    {this.getCheckbox()}
                </td>
                <td>{(this.props.label != '') ? <label htmlFor={this.props.id} style={this.props.labelStyle}><span className="clickable">{this.props.label}</span></label> : null}</td>
            </tr></table>
        </React.Fragment>;
    }
}
